import $ from 'jquery'
import {ReportGroupingLevel} from '../../constants'
import {Feature, isEnabled} from '../../../features'
import {TimeApprovalStatus} from 'constants'
import TTDetailReportEditConfigController from './TTDetailReportEditConfigController'

export default class TTDetailReportEditFormConfigController extends TTDetailReportEditConfigController {}

TTDetailReportEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function( reportParameters ){
    const results = $.extend({}, reportParameters);
    let groupingSelection = [results.firstGroupingLevel, results.secondGroupingLevel, results.thirdGroupingLevel];

    if ( !isEnabled(Feature.BTY)){
        groupingSelection = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(ReportGroupingLevel.BILLING_TYPE, groupingSelection);
    }
    if ( !isEnabled(Feature.UGR)){
        groupingSelection = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(ReportGroupingLevel.USER_GROUP, groupingSelection);
    }
    if ( !isEnabled(Feature.TTA)) {
        results.timeApprovalStatus = TimeApprovalStatus.BOTH;
    }
    results.firstGroupingLevel = groupingSelection[0];
    results.secondGroupingLevel = groupingSelection[1];
    results.thirdGroupingLevel = groupingSelection[2];
    return results;
};

TTDetailReportEditFormConfigController.prototype.getJoinCommentsByTask = function ()
{
    return this.joinCommentsCheckbox.prop("checked");
};



// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/ttDetail/TTDetailReportEditFormConfigController.js